import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class QueueObservabilityService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getOverview() {
        try {
            const body = await withRetry(() => this.api.getOverview(), { maxRetries: 2 });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Kuyruk özeti alınamadı');
        }
    }

    async retryFailed(queueName, limit = 100) {
        try {
            const body = await this.api.retryFailed({ queueName, limit });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Yeniden deneme başarısız');
        }
    }

    async drain(queueName) {
        try {
            const body = await this.api.drain({ queueName });
            return { success: body.success !== false, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Kuyruk boşaltılamadı');
        }
    }

    async removeJob(jobId) {
        try {
            const body = await this.api.removeJob({ jobId });
            return { success: body.success !== false, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'İş silinemedi');
        }
    }

    async getTrace(correlationId) {
        try {
            const body = await withRetry(() => this.api.getTrace(correlationId), { maxRetries: 2 });
            return { success: body.success !== false, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Korelasyon izi alınamadı');
        }
    }

    async enqueueHeavyTask(payload = {}) {
        try {
            const body = await this.api.enqueueHeavyTask(payload);
            return {
                success: body.success !== false,
                data: body.data,
                message: body.message
            };
        } catch (error) {
            throw this._handleError(error, 'Ağır iş kuyruğa eklenemedi');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
